import { createRouter, createWebHistory } from 'vue-router'
import Login from '../components/Login.vue'
import DroneMapping from '../components/DroneMapping.vue'
import auth from '../services/auth'
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'DroneMapping',
    component: DroneMapping,
    meta: { requiresAuth: true }
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes
})
// 認証ガード
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    try {
      await auth.getCurrentUser()
      next()
    } catch (error) {
      next('/login')
    }
  } else {
    next()
  }
})
export default router
